import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import ArticlesFaqSection from './components/ArticlesFaqSection';
import SeoArticlesSection from './components/SeoArticlesSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <StatsSection />
          <CategorySection />
          <FeaturesSection />
          <ArticlesFaqSection />
          <SeoArticlesSection />
          <CtaSection />
        </article>
      </main>
      <Footer />
    </>
  );
}